module.exports = __webpack_public_path__ + "img/payroll_success_checked.1e99cfe9.svg";